import { errorMessage } from "../../common/message";
import { myAxios } from "../../common/myAxios";

const getDataFaqs = async (data) => {
    try {
        return new Promise((resolve, reject) => {
            myAxios
                .post("/faq/search", data)
                .then((res) => {
                    resolve(res.data.data);
                })
                .catch((error) => {
                    errorMessage(error, reject);
                });
        });
    } catch (error) {
        console.error("Error in Faq listing", error);
    }
};
export { getDataFaqs };
